// src/pages/admin/NoticiasAdmin.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const CATEGORIAS = ['sostenibilidad','tips','productos','empresa','comunidad'];
const EMPTY = { titulo:'', resumen:'', contenido:'', imagen_url:'', categoria:'sostenibilidad', publicada:false, destacada:false };

export default function NoticiasAdmin() {
  const [noticias, setNoticias] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');

  const load = () => api.get('/noticias/todas').then(r => setNoticias(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const abrir = (n = null) => {
    setEditId(n?.id || null);
    setForm(n ? { titulo:n.titulo, resumen:n.resumen||'', contenido:n.contenido||'', imagen_url:n.imagen_url||'', categoria:n.categoria||'sostenibilidad', publicada:!!n.publicada, destacada:!!n.destacada } : EMPTY);
    setModal(true);
    setMediaUrl('');
  };

  const guardar = async () => {
    if (!form.titulo) return toast.error('Titulo requerido');
    setLoading(true);
    try {
      if (editId) {
        await api.put('/noticias/' + editId, form);
        toast.success('Noticia actualizada');
      } else {
        await api.post('/noticias', form);
        toast.success('Noticia creada');
      }
      setModal(false);
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Error'); }
    finally { setLoading(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('Eliminar esta noticia?')) return;
    try {
      await api.delete('/noticias/' + id);
      toast.success('Noticia eliminada');
      load();
    } catch(e) { toast.error('Error al eliminar'); }
  };

  const insertarMedia = (tipo) => {
    if (!mediaUrl) return toast.error('Ingresa una URL');
    let tag = '';
    if (tipo === 'imagen') {
      tag = '\n![imagen](' + mediaUrl + ')\n';
    } else if (tipo === 'video') {
      // Detectar YouTube
      const ytMatch = mediaUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
      if (ytMatch) {
        tag = '\n[VIDEO:' + mediaUrl + ']\n';
      } else {
        tag = '\n[VIDEO:' + mediaUrl + ']\n';
      }
    }
    setForm(f => ({ ...f, contenido: (f.contenido || '') + tag }));
    setMediaUrl('');
    toast.success(tipo === 'imagen' ? 'Imagen insertada' : 'Video insertado');
  };

  return (
    <div>
      <div style={{ background:"#fff", borderBottom:"1px solid var(--border)", padding:"14px 28px", position:"sticky", top:0, zIndex:10, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:"var(--forest)" }}>Noticias ({noticias.length})</h1>
        <button className="btn btn-primary" style={{ background:"#9FBE6A", color:"#1C3A1E" }} onClick={() => abrir()}>+ Nueva noticia</button>
      </div>

      <div style={{ padding:"24px 28px" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px,1fr))", gap:16 }}>
          {noticias.map(n => (
            <div key={n.id} className="card">
              {n.imagen_url && (
                <div style={{ height:160, overflow:"hidden", borderRadius:"var(--r-lg) var(--r-lg) 0 0" }}>
                  <img src={n.imagen_url} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                </div>
              )}
              <div className="card-body">
                <div style={{ display:"flex", gap:6, marginBottom:8, flexWrap:"wrap" }}>
                  <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(159,190,106,0.15)", color:"var(--forest)", fontWeight:700 }}>{n.categoria}</span>
                  {n.publicada ? <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(45,90,48,0.1)", color:"#2c5e2e", fontWeight:700 }}>Publicada</span> : <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(200,100,0,0.1)", color:"#c86400", fontWeight:700 }}>Borrador</span>}
                  {n.destacada && <span style={{ fontSize:11, padding:"2px 8px", borderRadius:20, background:"rgba(255,200,0,0.15)", color:"#b8860b", fontWeight:700 }}>⭐ Destacada</span>}
                </div>
                <h3 style={{ fontSize:15, fontWeight:700, color:"var(--forest)", marginBottom:6 }}>{n.titulo}</h3>
                <p style={{ fontSize:12, color:"var(--ink-faint)", marginBottom:12, lineHeight:1.5 }}>{n.resumen}</p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  <button onClick={() => abrir(n)} className="btn btn-outline btn-sm" style={{ flex:1 }}>Editar</button>
                  <button onClick={() => eliminar(n.id)} style={{ padding:"5px 12px", borderRadius:"var(--r-sm)", border:"none", background:"#fcebeb", color:"#a32d2d", fontWeight:700, fontSize:12, cursor:"pointer" }}>🗑️</button>
                </div>
                {n.publicada && (
                  <div style={{ marginTop:8, display:"flex", gap:6, flexWrap:"wrap" }}>
                    <span style={{ fontSize:10, fontWeight:700, color:"var(--ink-faint)", width:"100%", marginBottom:2 }}>COMPARTIR</span>
                    <button onClick={() => window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://wawita.co/noticias/' + n.slug), '_blank')} style={{ padding:"4px 10px", borderRadius:6, border:"none", background:"#1877F2", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" }}>Facebook</button>
                    <button onClick={() => window.open('https://wa.me/?text=' + encodeURIComponent(n.titulo + ' - https://wawita.co/noticias/' + n.slug), '_blank')} style={{ padding:"4px 10px", borderRadius:6, border:"none", background:"#25D366", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" }}>WhatsApp</button>
                    <button onClick={() => window.open('https://www.instagram.com/wawitaeco', '_blank')} style={{ padding:"4px 10px", borderRadius:6, border:"none", background:"linear-gradient(45deg,#f09433,#dc2743,#bc1888)", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" }}>Instagram</button>
                    <button onClick={() => window.open('https://www.tiktok.com/@wawitaeco', '_blank')} style={{ padding:"4px 10px", borderRadius:6, border:"none", background:"#010101", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" }}>TikTok</button>
                    <button onClick={() => { navigator.clipboard.writeText('https://wawita.co/noticias/' + n.slug); }} style={{ padding:"4px 10px", borderRadius:6, border:"1px solid rgba(28,58,30,0.2)", background:"#fff", color:"var(--forest)", fontSize:11, fontWeight:700, cursor:"pointer" }}>🔗 Copiar</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {modal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:24, overflowY:"auto" }}>
          <div className="card" style={{ width:"100%", maxWidth:700, margin:"auto" }}>
            <div className="card-header">
              <span className="card-title">{editId ? "Editar noticia" : "Nueva noticia"}</span>
              <button onClick={() => setModal(false)} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer" }}>✕</button>
            </div>
            <div className="card-body" style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div className="form-group">
                <label className="form-label">Titulo *</label>
                <input className="form-input" value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))} placeholder="Titulo de la noticia" />
              </div>
              <div className="form-group">
                <label className="form-label">URL imagen destacada</label>
                <input className="form-input" value={form.imagen_url} onChange={e=>setForm(f=>({...f,imagen_url:e.target.value}))} placeholder="https://res.cloudinary.com/..." />
                {form.imagen_url && <img src={form.imagen_url} alt="" style={{ marginTop:8, width:"100%", maxHeight:150, objectFit:"cover", borderRadius:8 }} onError={e=>e.target.style.display="none"} />}
              </div>
              <div className="form-group">
                <label className="form-label">Resumen</label>
                <textarea className="form-input" rows={2} value={form.resumen} onChange={e=>setForm(f=>({...f,resumen:e.target.value}))} placeholder="Descripcion corta..." style={{ resize:"vertical" }} />
              </div>

              {/* Insertar media */}
              <div style={{ background:"var(--cream)", borderRadius:10, padding:14 }}>
                <div style={{ fontWeight:700, fontSize:13, color:"var(--forest)", marginBottom:10 }}>Insertar imagen o video en el contenido</div>
                <div style={{ display:"flex", gap:8 }}>
                  <input className="form-input" style={{ flex:1, fontSize:13 }} value={mediaUrl} onChange={e=>setMediaUrl(e.target.value)} placeholder="URL de imagen o video (YouTube, Cloudinary...)" />
                  <button onClick={() => insertarMedia("imagen")} className="btn btn-outline btn-sm">🖼️ Imagen</button>
                  <button onClick={() => insertarMedia("video")} className="btn btn-outline btn-sm">🎥 Video</button>
                </div>
                <div style={{ fontSize:11, color:"var(--ink-faint)", marginTop:6 }}>Las imágenes y videos se mostrarán en el orden en que aparecen en el contenido</div>
              </div>

              <div className="form-group">
                <label className="form-label">Contenido</label>
                <textarea className="form-input" rows={10} value={form.contenido} onChange={e=>setForm(f=>({...f,contenido:e.target.value}))} placeholder="Escribe el contenido... Usa ![imagen](url) para imágenes y [VIDEO:url] para videos" style={{ resize:"vertical", fontFamily:"monospace", fontSize:13 }} />
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select className="form-input" value={form.categoria} onChange={e=>setForm(f=>({...f,categoria:e.target.value}))}>
                    {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:10, justifyContent:"center" }}>
                  <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:14, fontWeight:600 }}>
                    <input type="checkbox" checked={form.publicada} onChange={e=>setForm(f=>({...f,publicada:e.target.checked}))} style={{ accentColor:"#9FBE6A" }} />
                    Publicar ahora
                  </label>
                  <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer", fontSize:14, fontWeight:600 }}>
                    <input type="checkbox" checked={form.destacada} onChange={e=>setForm(f=>({...f,destacada:e.target.checked}))} style={{ accentColor:"#9FBE6A" }} />
                    Destacada
                  </label>
                </div>
              </div>

              <div style={{ display:"flex", gap:10, marginTop:8 }}>
                <button className="btn btn-primary" style={{ flex:1, background:"#9FBE6A", color:"#1C3A1E" }} onClick={guardar} disabled={loading}>
                  {loading ? "Guardando..." : editId ? "Guardar cambios" : "Crear noticia"}
                </button>
                <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
